import { useLocation, Navigate } from 'react-router-dom'
import { useSelector } from "react-redux";
import RootLayout from '../layouts/RootLayout';

const RequireAuth = () => {
    const isAuth = useSelector((state) => state.auth.isAuthenticated);
    const location  = useLocation();

    return (
        isAuth ?
            <RootLayout /> :
            <Navigate to="/login" state={{ from: location}} replace />
    )
}

export default RequireAuth;